import { DemoCourseIntroductioBanner } from '@/constant/imgImport';
import {
  ECourseTabSectionKey,
  TEnterpriseProfileCourseTabSection,
} from '@/interfaces/enterprise-profile/course_tab.interface';

export const hashCourseSectionName = {
  [ECourseTabSectionKey.Introduction]: 'Giới thiệu',
  [ECourseTabSectionKey.HighlightCourses]: 'Khoá học nổi bật',
  [ECourseTabSectionKey.BusinessCourses]: 'Khoá học từ doanh nghiệp',
  [ECourseTabSectionKey.EliteTeachers]: 'Giáo viên ưu tú',
};

export const defaultCourseSection: TEnterpriseProfileCourseTabSection = [
  {
    sectionName: hashCourseSectionName[ECourseTabSectionKey.Introduction],
    sectionKey: ECourseTabSectionKey.Introduction,
    elements: {
      title: 'Mở rộng kiến thức qua các khoá học',
      backgroundImage: DemoCourseIntroductioBanner,
    },
    isActive: true,
  },
  {
    sectionName: hashCourseSectionName[ECourseTabSectionKey.HighlightCourses],
    sectionKey: ECourseTabSectionKey.HighlightCourses,
    isActive: true,
  },
  {
    sectionName: hashCourseSectionName[ECourseTabSectionKey.BusinessCourses],
    sectionKey: ECourseTabSectionKey.BusinessCourses,
    isActive: true,
  },
  {
    sectionName: hashCourseSectionName[ECourseTabSectionKey.EliteTeachers],
    sectionKey: ECourseTabSectionKey.EliteTeachers,
    elements: {
      fullName: 'Lê Quốc Tuấn',
      academicDegree: 'Tiến Sĩ, Bác sĩ',
      descriptionContent:
        'Lorem ipsum dolor sit amet consectetur. Consequat auctor consectetur nunc vitae dolor blandit. Elit enim massa etiam neque laoreet lorem sed. Vitae eu accumsan ultrices neque blandit proin elit ac. In turpis felis urna et aliquet sed lacus.',
      image: '/img/Teacher.png',
    },
    isActive: true,
  },
];
